import { Content, useRental } from '@vodafoneis/sjonvarpskjarni-js-lib';
import moment from 'moment';

export const useRentedUntil = (content: Content) => {
	const rental = useRental(content);

	return rental?.validUntil ? moment(rental?.validUntil).format('D. MMMM') : null;
};
